module.exports = __webpack_public_path__ + "static/img/5.65a54ea1.jpg";